<div id="banner-blog" class="swiper-background d-lg-flex align-items-center pt-5 pt-lg-0">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-7">
                <div class="title-container">
                    <div class="pretitle-container mb-3">
                        <span class="p-display-bold border-y-1 border-primary-900 primary-900">
                            BLOG SEGOFINANCE
                        </span>
                    </div>

                    <h1 class="h1-display primary-900 mb-lg-2">
                        Descubre todo sobre<br class="d-none d-md-block d-xl-none"> el mundo de la<br class="d-none d-md-block d-xl-none"> inversión alternativa
                    </h1>

                    <div class="subtitle-container d-none d-lg-block">
                        <p class="p-display primary-900 mb-2">
                            Espacio de novedades, oportunidades y entrevistas exclusivas.
                        </p>
                        <p class="p-display-bold primary-900">
                            AHORRA · INVIERTE · RENTABILIZA
                        </p>
                    </div>
                </div>
            </div>

            <div class="mt-3 mt-lg-4">
                <app-btn-link [linkId]="'btn-banner-blog'" [linkType]="'href'" [linkTarget]="'_blank'" [linkTitle]="'¡Visítanos!'"  [linkUrl]="'https://blog.segofinance.com'"></app-btn-link>
            </div>
        </div> 
    </div>
</div>